import React from 'react';
import DOMPurify from 'dompurify';

const AddInnerHtml = ({text, classNames}) => {
  if (classNames === undefined) {
    classNames="";
  }

  classNames += " WYSIWYG"

  const handleAnchorClick = (e) => {
    const targetLink = e.target.closest("a");
    if (!targetLink) return;
    e.preventDefault();
    if (targetLink.href.startsWith("mailto:")) {
      window.location.href = targetLink.href;
    } else {
      window.open(targetLink.href, "_blank", "noopener");
    }
  };

  // Sanitize the HTML content
  const sanitizedText = DOMPurify.sanitize(text, {
    ALLOWED_TAGS: ['p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id', 'style']
  });

  return (
    <>
      <div
        onClick={handleAnchorClick}
        className={classNames}
        dangerouslySetInnerHTML={{ __html: sanitizedText}}
      >
      </div>
    </>
  );
};

export default AddInnerHtml;